import React from 'react';

import ButtonWithConfirmation from '../../../../../ButtonWithConfirmation';

import BillPaymentService from '../../../../../../services/BillPaymentService';

function ConfirmationMessage({ billPayment }) {
  const isLastPointVisible = !!billPayment.check_disbursement_data.check_date;

  return (
    <div>
      <p className="mb-4">
        Are you sure you want to void this payment? Doing this will not reverse
        the bill payment. If the bill needs to be paid, this bill payment will
        need to reversed and a new bill payment created to pay the bill(s).
      </p>
      <ul className="list-disc pl-4 flex flex-col gap-2">
        <li>
          If funds have already been drawn to make this bill payment, those
          funds will be returned after 2-3 days
        </li>
        {isLastPointVisible && (
          <li>
            The check has already been printed. If the void is successful, the a
            stop will be placed on the check
          </li>
        )}
      </ul>
    </div>
  );
}

export default function VoidBillPaymentButton({ billPayment, refetch }) {
  if (!billPayment) {
    return null;
  }

  if (
    !(
      billPayment.source === 'Check' &&
      (!!billPayment.check_use_billcom || !!billPayment.check_use_lob) &&
      !billPayment.check_disbursement_data.cleared_date &&
      !!billPayment.billcom_sentpay_id &&
      billPayment.billcom_sentpay_status === 'Paid'
    ) ||
    billPayment.vendor_direct_disbursement_data?.disbursement_status ===
      'Done' ||
    billPayment.status === 'void'
  ) {
    return null;
  }

  return (
    <div>
      <ButtonWithConfirmation
        label="Void bill payment"
        confirmationMessage={<ConfirmationMessage billPayment={billPayment} />}
        confirmButtonLabel="Yes, void the bill payment"
        cancelButtonLabel="No, cancel"
        successMessage="This bill payment has been successfully voided"
        onConfirm={() => BillPaymentService.voidBillComPayment(billPayment.id)}
        refetch={refetch}
      />
    </div>
  );
}
